import { MobileFilled } from "@ant-design/icons";
import React from "react";

import { ReactComponent as AppleFilled } from "../assets/images/icons/apple.svg";
import { ReactComponent as GoogleOutlined } from "../assets/images/icons/google.svg";
import { ReactComponent as MailFilled } from "../assets/images/icons/email.svg";

/**
 * LoginOption - JSX component with Tailwind CSS
 * Reusable button for different login methods
 * 
 * Features:
 * - Supports Google, Apple, Email, Mobile login types
 * - Icon + text layout
 * - Click handler for login action
 * - Consistent styling across all options
 * 
 * @param {string} optionType - Type of login (google, apple, email, mobile)
 * @param {string} optionText - Button text to display
 * @param {function} onOptionClick - Click handler
 */
function LoginOption({ optionType, optionText, onOptionClick }) {
  return (
    <button
      className="w-full flex items-center justify-center gap-3 px-6 h-12 bg-app-card border-none rounded-full text-[#FEFCEB] hover:bg-[#0b2f57] active:bg-[#05182b] transition-all"
      onClick={onOptionClick}
    >
      <RenderIcon type={optionType} />
      <span className="text-base font-medium">{optionText}</span>
    </button>
  );
}

function RenderIcon({ type }) {
  switch (type) {
    case "google": {
      return <GoogleOutlined />;
    }
    case "apple": {
      return <AppleFilled />;
    }
    case "email": {
      return <MailFilled />;
    }
    case "mobile": {
      return <MobileFilled />;
    }
    default: {
      return <></>;
    }
  }
}

export default LoginOption;
